var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comment"},[_c('span',{staticClass:"comment__created"},[_vm._v(_vm._s(_vm.displayDate(_vm.message.created_at)))]),_vm._v(" "),_c('span',{staticClass:"comment__author"},[_vm._v(" "+_vm._s(_vm.message.author))]),_vm._v(" "),_c('p',{staticClass:"comment__content"},[_vm._v("\n    "+_vm._s(_vm.message.message)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }